<template>
  <div>
    <!-- <HeaderNavbar /> -->
    <el-row>
      <HeaderNavbar :activeIndex="'3'" />
    </el-row>
    <el-alert title="先选择城市，再点击开始评估按钮即可获取结果" type="error">
    </el-alert>

    <div class="flex-box">
      <el-collapse accordion v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <h3 style="color: #f56c6c">
              选择评估的城市<i class="header-icon el-icon-info"></i>
            </h3>
          </template>
          <div>
            <el-row style="text-align: left">
              城市：
              <el-cascader
                ref="cascader"
                class="search-bar-cities"
                :options="options"
                :props="{ multiple: true, expandTrigger: 'hover' }"
                collapse-tags
                v-model="assesscity"
                clearable
                filterable
                size="medium"
              ></el-cascader>
            </el-row>
            <el-row style="text-align: left">
              评估城市（{{ singleCities().length }}个城市）：
              <el-tag
                v-for="city in singleCities()"
                :key="city[0] + city[1]"
                :disable-transitions="false"
                :style="{
                  marginRight: '4px',
                  marginBottom: '4px',
                }"
              >
                <!-- {{ city[0] }} / {{ city[1] }} -->{{ city }}
              </el-tag>
            </el-row>
            <el-row>
              <el-button type="danger" @click="goto">开始评估</el-button>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>

      <el-row>
        <el-tabs v-model="tabsValue" tab-position="left">
          <el-tab-pane
            name="pull"
            :disabled="
              assesscity.length > max_assess_city ||
              gotoAssessCity.length > max_assess_city
            "
          >
            <span slot="label" @click="message('pull')">
              污染物浓度时间序列图
            </span>
            <div style="min-height: 600px">
              <PullTimeseries
                :assesscity="assesscityEN"
                :show="tabsValue == 'pull'"
              />
            </div>
          </el-tab-pane>

          <el-tab-pane label="污染物浓度地图" name="pullmap">
            <div style="min-height: 600px">
              <PullsMaps
                :assesscity="assesscityEN"
                :show="tabsValue == 'pullmap'"
              />
            </div>
          </el-tab-pane>

          <el-tab-pane
            name="hwindex"
            :disabled="
              assesscity.length > max_assess_city ||
              gotoAssessCity.length > max_assess_city
            "
          >
            <span slot="label" @click="message('hwindex')">
              “人努力-天帮忙”指数时间序列图
            </span>
            <div style="min-height: 600px">
              <HWindexTimeseries
                :assesscity="assesscityEN"
                :show="tabsValue == 'hwindex'"
              />
            </div>
          </el-tab-pane>

          <el-tab-pane label="“人努力-天帮忙”指数坐标图" name="hwindexAxis">
            <div style="min-height: 600px">
              <HWindexAxis
                :assesscity="assesscityEN"
                :show="tabsValue == 'hwindexAxis'"
              />
            </div>
          </el-tab-pane>

          <el-tab-pane label="“人努力-天帮忙”指数地图" name="hwindexMap">
            <div style="min-height: 600px">
              <HWindexMaps
                :assesscity="assesscityEN"
                :show="tabsValue == 'hwindexMap'"
              />
            </div>
          </el-tab-pane>

          <el-tab-pane label="污染物浓度等级" name="ext">
            <div style="min-height: 600px">
              <PullExt :assesscity="assesscityEN" :show="tabsValue == 'ext'" />
            </div>
          </el-tab-pane>

          <el-tab-pane label="污染物降幅及综合改善情况" name="reduce">
            <div style="min-height: 600px">
              <PullsReduce
                :assesscity="assesscityEN"
                :show="tabsValue == 'reduce'"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="监视坐标图" name="monitor">
            <div style="min-height: 600px">
              <PullMonitor
                :assesscity="assesscityEN"
                :show="tabsValue == 'monitor'"
              /></div
          ></el-tab-pane>

          <el-tab-pane
            label="六大污染物雷达图"
            name="radar"
            :disabled="
              assesscity.length > max_assess_city ||
              gotoAssessCity.length > max_assess_city
            "
            ><span slot="label" @click="message('radar')">
              六大污染物雷达图
            </span>
            <div style="min-height: 600px">
              <PullRadar
                :assesscity="assesscityEN"
                :show="tabsValue == 'radar'"
              /></div
          ></el-tab-pane>
        </el-tabs>
      </el-row>
    </div>

    <el-row>
      <HFooter />
    </el-row>
  </div>
</template>
<style scoped>
.flex-box {
  max-width: 1440px;
  margin: 0 auto;
  padding-left: 15px;
}
a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}
.content-father {
  display: block;
  position: relative;
}

.search-bar-cities {
  min-width: 265px;
}

.tab-title {
  border: none;
  padding: 0;
  background: none;
}
</style>
<script>
// @ is an alias to /src
import HeaderNavbar from "@/components/HeaderNavbar.vue";
import HFooter from "@/components/HFooter.vue";
import PullTimeseries from "@/components/pull/PullTimeseries.vue";
import PullsMaps from "@/components/pull/PullsMaps.vue";
import HWindexTimeseries from "@/components/pull/HWindexTimeseries.vue";
import HWindexAxis from "@/components/pull/HWindexAxis.vue";
import HWindexMaps from "@/components/pull/HWindexMaps.vue";
import PullExt from "@/components/pull/PullExt.vue";
import PullMonitor from "@/components/pull/PullMonitor.vue";
import PullsReduce from "@/components/pull/PullsReduce.vue";
import PullRadar from "@/components/pull/PullRadar.vue";

export default {
  // name: "Home",
  data() {
    return {
      imgsrc: require("@/assets/weather_adj.png"),
      imgsrc_hwindex: require("@/assets/hwindex.png"),
      imgsrc_monitor: require("@/assets/monitor.png"),
      tabsValue: "pull",
      activeNames: "1",

      initFlag: false,

      max_assess_city: 17,

      options: [],
      cities: [],
      assesscity: [
        // ["直辖市", "北京"],
        // ["直辖市", "天津"],
        // ["河北", "石家庄"],
        // ["山西", "太原"],
        // ["河南", "郑州"],
        // ["陕西", "西安"],
        // ["山东", "济南"],
      ],

      gotoAssessCity: [
        ["河北", "石家庄"],
        ["山西", "太原"],
        ["河南", "郑州"],
        ["陕西", "西安"],
        ["山东", "济南"],
        ["安徽", "合肥"],
        ["江苏", "南京"],
        ["内蒙古", "呼和浩特"],
        ["江西", "南昌"],
      ],
    };
  },
  components: {
    HeaderNavbar,
    HFooter,
    PullTimeseries,
    PullsMaps,
    HWindexTimeseries,
    HWindexAxis,
    HWindexMaps,
    PullExt,
    PullMonitor,
    PullsReduce,
    PullRadar,
  },

  watch: {
    assesscity: function (val) {
      // this.gotoAssessCity = val;
      // let assesscity;
      // console.log(this.$refs["cascader"]);
    },

    gotoAssessCity: function (val) {},
  },
  computed: {
    // 计算属性的 getter
    assesscityEN: function () {
      let city_array = [];
      this.gotoAssessCity.forEach((element) => {
        city_array.push(this.getCityEN(element[1]));
      });
      return city_array;
    },
  },
  methods: {
    singleCities() {
      // 去重
      let normalCities = [];
      this.assesscity.forEach((element) => {
        normalCities.push(element[1]);
      });

      normalCities = Array.from(new Set(normalCities));

      return normalCities;
    },
    goto() {
      let less5 = ["pull", "hwindex", "radar"];
      let normalCities = this.singleCities();
      if (
        normalCities.length > this.max_assess_city &&
        less5.indexOf(this.tabsValue) != -1
      ) {
        this.$message.error(
          "请选择不多于" + this.max_assess_city + "个城市进行评估"
        );
      } else {
        let gotoCC = [];
        this.cities.forEach((element) => {
          if (normalCities.indexOf(element[1]) != -1) {
            gotoCC.push(element);
          }
        });

        this.gotoAssessCity = gotoCC;
      }
    },

    message(newtab) {
      let less5 = ["pull", "hwindex", "radar"];
      if (
        less5.indexOf(newtab) != -1 &&
        this.assesscity.length > this.max_assess_city
      ) {
        this.$message({
          type: "error",
          message: "请选择少于" + this.max_assess_city + "个城市进行评估",
        });
      }
    },
    // 根据城市的中文名返回城市的拼音
    getCityEN(city) {
      let prov = "";
      let cityname_en = "";
      for (let i = 0; i < this.cities.length; i++) {
        if (city == this.cities[i][1]) {
          prov = this.cities[i][0];
          cityname_en = this.cities[i][2];
          break;
        }
      }
      return [prov, city, cityname_en];
      // return cityname_en;
    },
  },
  created() {
    this.tabsValue = this.$route.params.content;

    const that = this;
    // 获取城市
    this.$axios
      // .post("/AQAssess/getData.php", {
      //   database: "cities",
      // })
      .get("/AQAssess/getcities")
      .then((res) => {
        this.cities = res.data;
        let options = [];
        let nation_all_cities = [];

        // console.log(this.cities);

        this.cities.forEach((element) => {
          nation_all_cities.push(element[1]);

          let add = false;
          for (let i = 0; i < options.length; i++) {
            if (options[i].value == element[0]) {
              options[i].children.push({
                value: element[1],
                label: element[1],
              });

              add = true;
              break;
            }
          }
          if (!add) {
            options.push({
              value: element[0],
              label: element[0],
              children: [{ value: element[1], label: element[1] }],
            });
          }

          // 添加到名单里面
        });

        // 汾渭平原
        let fenweipy = [
          "西安",
          "铜川",
          "宝鸡",
          "咸阳",
          "渭南",
          "太原",
          "阳泉",
          "长治",
          "晋城",
          "晋中",
          "运城",
          "临汾",
          "吕梁",
        ];

        let fwpy_option = {
          value: "汾渭平原",
          label: "汾渭平原",
          children: [],
        };
        fenweipy.forEach((city) => {
          fwpy_option.children.push({
            value: city,
            label: city,
          });
        });

        let twoP36 = [
          "秦皇岛",
          "枣庄",
          "东营",
          "潍坊",
          "泰安",
          "日照",
          "临沂",
          "洛阳",
          "平顶山",
          "许昌",
          "漯河",
          "三门峡",
          "商丘",
          "周口",

          "北京",
          "天津",
          "石家庄",
          "唐山",
          "廊坊",
          "保定",
          "沧州",
          "衡水",
          "邢台",
          "邯郸",
          
          "济南",
          "淄博",
          "济宁",
          "德州",
          "聊城",
          "滨州",
          "菏泽",
          "郑州",
          "开封",
          "安阳",
          "鹤壁",
          "新乡",
          "焦作",
          "濮阳",
        ];

        let twoP36_option = {
          value: "2+36城市",
          label: "2+36城市",
          children: [],
        };
        twoP36.forEach((city) => {
          twoP36_option.children.push({
            value: city,
            label: city,
          });
        });


        let twoP26 = [
          "北京",
          "天津",
          "石家庄",
          "唐山",
          "廊坊",
          "保定",
          "沧州",
          "衡水",
          "邢台",
          "邯郸",
          "太原",
          "阳泉",
          "长治",
          "晋城",
          "济南",
          "淄博",
          "济宁",
          "德州",
          "聊城",
          "滨州",
          "菏泽",
          "郑州",
          "开封",
          "安阳",
          "鹤壁",
          "新乡",
          "焦作",
          "濮阳",
        ];

        let twoP26_option = {
          value: "2+26城市",
          label: "2+26城市",
          children: [],
        };
        twoP26.forEach((city) => {
          twoP26_option.children.push({
            value: city,
            label: city,
          });
        });

        // 添加 苏皖鲁豫 区域
        let suwanluyu = [
          "淮北",
          "阜阳",
          "宿州",
          "亳州",
          "平顶山",
          "许昌",
          "漯河",
          "商丘",
          "周口",
          "驻马店",
          "南阳",
          "信阳",
          "徐州",
          "连云港",
          "宿迁",
          "青岛",
          "枣庄",
          "东营",
          "潍坊",
          "泰安",
          "日照",
          "临沂",
        ];

        let suwanluyu_option = {
          value: "苏皖鲁豫",
          label: "苏皖鲁豫",
          children: [],
        };
        suwanluyu.forEach((city) => {
          suwanluyu_option.children.push({
            value: city,
            label: city,
          });
        });

        //  长三角地区
        let changsanjiao = [
          "上海",
          "南京",
          "无锡",
          "徐州",
          "常州",
          "苏州",
          "南通",
          "连云港",
          "淮安",
          "盐城",
          "扬州",
          "镇江",
          "泰州",
          "宿迁",

          "杭州",
          "宁波",
          "嘉兴",
          "湖州",
          "绍兴",
          "舟山",

          "合肥",
          "芜湖",
          "蚌埠",
          "淮南",
          "马鞍山",
          "淮北",
          "滁州",
          "阜阳",
          "宿州",
          "六安",
          "亳州",

        ];

        let changsanjiao_option = {
          value: "长三角地区",
          label: "长三角地区",
          children: [],
        };
        changsanjiao.forEach((city) => {
          changsanjiao_option.children.push({
            value: city,
            label: city,
          });
        });

        console.log(changsanjiao)

        // 环渤海
        let huanbohai = ["北京", "唐山", "沧州", "廊坊", "天津"];
        let huanbohai_option = {
          value: "环渤海",
          label: "环渤海",
          children: [],
        };
        huanbohai.forEach((city) => {
          huanbohai_option.children.push({
            value: city,
            label: city,
          });
        });

        // 沿太行山

        let yantaihangshan = ["石家庄", "邯郸", "邢台", "保定", "衡水"];
        let yantaihangshan_option = {
          value: "沿太行山",
          label: "沿太行山",
          children: [],
        };
        yantaihangshan.forEach((city) => {
          yantaihangshan_option.children.push({
            value: city,
            label: city,
          });
        });

        // 全国

        let nation_all_cities_option = {
          value: "全国" + nation_all_cities.length + "个城市",
          label: "全国" + nation_all_cities.length + "个城市",
          children: [],
        };
        nation_all_cities.forEach((city) => {
          nation_all_cities_option.children.push({
            value: city,
            label: city,
          });
        });

        options.push(fwpy_option); // 汾渭平原
        options.push(twoP36_option); // 2+26
        options.push(suwanluyu_option); // 苏皖鲁豫
        options.push(changsanjiao_option); // 长三角地区
        // options.push(huanbohai_option); // 环渤海
        // options.push(yantaihangshan_option); 
        options.unshift(nation_all_cities_option); // 全国

        that.options = options;
      })
      .catch((e) => {
        this.$message({
          type: "error",
          message: "获取城市数据失败",
        });
      });
  },
};
</script>
